// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1154":"e43b80e9","1973":"f1ea6deb","1987":"fe36ba62","2336":"50902648","2897":"4b8cc62b","4795":"2c7f52d3","9011":"43b368c0","9639":"3004ffaa"}[chunkId] + ".chunk.css";
};